import { logError } from "@entrilia/shared/logging.ts";
import biApi from "../../../../../../api/biApi.ts";
import type { MetaDataResponse, MetaDescriptorBase } from "../../../../../../api/types/svTypes.ts";
import { MetaItemType } from "../../../../../../api/types/svTypes.ts";
import type { DataSetMetaDataState } from "../types/metaDataState.types.ts";
import { createTypedAsyncThunk } from "../utils/createTypedAsyncThunk.ts";
import { createCurrentReportAction, createMetaDataAction } from "../utils/storeUtils.ts";
import { fieldsStateActions } from "./fieldStatesThunks.ts";

export const changeDataSet = createTypedAsyncThunk("store/changeDataSet", (dataSetId: string, { dispatch }) => {
  dispatch(createMetaDataAction("changeDataSet", dataSetId));
  dispatch(fieldsStateActions.resetFieldsState(undefined));
  dispatch(createCurrentReportAction("updateReportDataSetId", dataSetId));
});

export const loadMetaData = createTypedAsyncThunk("store/loadMetaData", async (_, { dispatch }) => {
  try {
    const response = await biApi.loadMeta();
    if (response.success && response.data) {
      const dataSets = refineMetaDataResponse(response.data);
      dispatch(
        createMetaDataAction("update", {
          dataSets,
          loaded: true,
          loadingFailed: false,
        })
      );
    } else {
      dispatch(createMetaDataAction("update", { loadingFailed: true, loaded: false }));
    }
  } catch (error) {
    logError(error, "loadMetaData");
    dispatch(createMetaDataAction("update", { loadingFailed: true, loaded: false }));
  }
});

const setItemType = <T extends MetaDescriptorBase>(objs: T[], itemType: MetaItemType) => {
  objs.forEach((obj) => (obj.itemType = itemType));
  return objs;
};

const refineMetaDataResponse = (data: MetaDataResponse) => {
  return data.dataSets.map<DataSetMetaDataState>((dataset) => ({
    dataSetId: dataset.dataSetId,
    dimensionsStructure: dataset.dimensionsStructure,
    measuresStructure: dataset.measuresStructure,
    dimensions: setItemType(dataset.dimensions, MetaItemType.DIMENSION),
    measures: [],
    allMeasures: setItemType(dataset.measures, MetaItemType.MEASURE),
    allMetrics: setItemType(dataset.metrics, MetaItemType.METRIC),
    aggregations: setItemType(dataset.aggregations ?? [], MetaItemType.AGGREGATION),
    allAggregations: setItemType(dataset.aggregations ?? [], MetaItemType.AGGREGATION),
    functions: dataset.functions,
    measureGroups: dataset.measureGroups,
    measureSubgroups: dataset.measureSubgroups ?? [],
    metrics: [],
    metricsStructure: dataset.metricsStructure,
    currencyDimensions: dataset.currencyDimensions,
    customFormulas: dataset.customFormulas,
    ledgers: dataset.ledgers,
  }));
};
